import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { PhoneVerificationConfigService } from "./phone-verification.config";

/**
 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
 */
@Injectable({
	providedIn: "root",
})
export class PhoneVerificationService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: PhoneVerificationConfigService
	) {}

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(AccountAppCommand.PhoneVerificationRequestSmsCode)" instead
	 */
	requestCode(phoneNumber: string): Observable<string> {
		return this.httpClient.post<string>({
			url: this.config.getEndpoint(),
			data: { phoneNumber },
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(AccountAppCommand.PhoneVerificationVerifyCode)" instead
	 */
	verifyCode(smsCode: number): Observable<number> {
		return this.httpClient.patch<number>({
			url: `${this.config.getEndpoint()}/${smsCode}`,
		});
	}
}
